module.exports = __webpack_public_path__ + "assets/img/block-2715da5f.png";